<template>
  <a-layout class="width-100 flex-display" style="height: 100vh">

    <a-layout-header class="header" v-show="showHeader">
      <Topbar /> <!--头部-->
    </a-layout-header>
    <a-layout-content>
      <Watermark />
      <router-view /> <!--中间内容-->
      <div class="map-wrapper" v-show="showMap" :style="style">
      <GMap />
      </div>
      <operationPanel/>
    </a-layout-content>

  </a-layout>
</template>

<script lang="ts" setup>
import GMap from '/@/components/CesiumMap.vue'
import Topbar from '/@/components/common/topbar.vue'
import { computed, nextTick, onMounted, ref, watch } from 'vue'
import { getRoot } from '/@/root'
import { EBizCode, ELocalStorageKey, ERouterName } from '/@/types'
import { useConnectWebSocket } from '/@/hooks/use-connect-websocket'
import EventBus from '/@/event-bus'
import operationPanel from './projects/operationPanel.vue'
import cookies from 'vue-cookies'
import Watermark from '/@/components/common/watermark.vue'

const root = getRoot()

const showHeader = computed(() => {
  return root.$store.state.headerVisible
})

const showMap = computed(() => {
  let flag = true
  const writePath = ['/tsa', '/dataUi', '/wayline', '/wayline-edit', '/wayline-edit-planar', '/wayline-edit-strip', '/create-plan', '/select-plan', '/flight-area', '/layer', '/task']
  let writeFlag = true
  writePath.forEach((path) => {
    if (root.$route.path.indexOf(path) > -1) {
      writeFlag = false
    }
  })
  if (writeFlag) {
    flag = false
  }
  return flag
})

const getStyle = () => {
  const style = {
    width: 0,
    height: 0
  }
  if (document) {
    const headerHeight = showHeader.value ? 60 : 0
    const dom = document.querySelector('.right')
    if (dom) {
      style.width = dom.scrollWidth + 'px'
      style.height = window.innerHeight - headerHeight + 'px'
      style.left = window.innerWidth - dom.scrollWidth + 'px'
      style.top = headerHeight + 'px'
    }

    const domTask = document.querySelector('.left-panel')
    if (domTask) {
      style.width = window.innerWidth - domTask.scrollWidth + 'px'
      style.height = window.innerHeight - headerHeight + 'px'
      style.left = domTask.scrollWidth + 'px'
      style.top = headerHeight + 'px'
    }

    if (!dom && !domTask) {
      if (
        root.$route.path.indexOf('dataUi') > -1 ||
        root.$route.path.indexOf('wayline-edit') > -1 ||
        root.$route.path.indexOf('wayline-edit-planar') > -1 ||
        root.$route.path.indexOf('/wayline-edit-strip') > -1
      ) {
        style.width = window.innerWidth + 'px'
        style.height = window.innerHeight - 80 + 'px'
        style.left = 0
        if (root.$route.path.indexOf('/dataUi') > -1) {
          style.top = 80 + 'px'
        }
      }
    }
  }
  return style
}

/**
* 消息处理器
*
* @param payload 消息负载
* @returns 无返回值
*/
const messageHandler = async (payload: any) => {
  if (!payload) {
    return
  }
  switch (payload.biz_code) {
    case EBizCode.DeviceUpgrade: {
      EventBus.emit('deviceUpgrade', payload)
      break
    }
    case EBizCode.DeviceLogUploadProgress: {
      EventBus.emit('deviceLogUploadProgress', payload)
      break
    }
  }
}

// 监听ws 消息
useConnectWebSocket(messageHandler)
let setTime = null
const style = ref({})
function handleResizeDom () {
  if (setTime) {
    clearInterval(setTime)
    setTime = null
  }
  setTime = setInterval(() => {
    const query = document.querySelector('.map-wrapper') as Element
    if (query) {
      style.value = getStyle()
    }
  }, 10)
}

watch(() => root.$route.path, () => {
  nextTick(() => {
    const query = document.querySelector('.map-wrapper')
    if (query) {
      style.value = getStyle()
    }
    handleResizeDom()
  })
}, { deep: true, immediate: true })
onMounted(() => {
  const token = cookies.get(ELocalStorageKey.Token)
  if (!token) {
    root.$router.push(ERouterName.PROJECT)
  }
  nextTick(() => {
    const query = document.querySelector('.map-wrapper')
    if (query) {
      style.value = getStyle()
    }
    handleResizeDom()
  })
})

const getClass = computed(() => {
  let cls = ''
  if (showHeader.value) {
    cls += 'custom'
  }
  return cls
})
</script>

<style lang="scss" scoped>
@use '/@/styles/index.scss' as *;
.map-wrapper{
  position: absolute;
  top: 60px;
  left: 0;
  z-index: 1;
}
.fontBold {
  font-weight: 500;
  font-size: 18px;
}

.header {
  position: relative;
  z-index: 1000;
  &:not(.custom){
  background-color: #061536;
  color: white;
  height: 60px;
  font-size: 15px;
  padding: 0 20px;
  }
  &.custom{
        height: 0;
    padding: 0;
    color: transparent;
    line-height: inherit;
    background: transparent;
  }
}
</style>
